(function () {

    "use strict";

    console.log("⭐ Review Summary Started");

    function buildSummary() {

        if (!window.MERGED_REVIEWS) {

            console.log("Waiting for MERGED_REVIEWS...");

            setTimeout(buildSummary, 500);

            return;

        }

        const reviews = window.MERGED_REVIEWS;

        let totalRating = 0;

        const distribution = {

            5: 0,
            4: 0,
            3: 0,
            2: 0,
            1: 0

        };

        reviews.forEach(function (review) {

            const rating = parseInt(review.rating, 10);

            totalRating += rating;

            if (distribution[rating] !== undefined) {

                distribution[rating]++;

            }

        });

        const average =
            reviews.length
                ? (totalRating / reviews.length).toFixed(1)
                : 0;

        window.REVIEW_SUMMARY = {

            average: parseFloat(average),

            total: reviews.length,

            totalRating: totalRating,

            distribution: distribution

        };

        console.log("✅ REVIEW SUMMARY");

        console.table(window.REVIEW_SUMMARY);

    }

    buildSummary();

})();